import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Nav = () => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const userName = localStorage.getItem("user_name");
  const dairyName = localStorage.getItem("dairy_name");

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <nav className="nav">
      {/* Left — dairy name */}
      <div className="nav-left">
        <span className="nav-dairy-name">🐄 {dairyName}</span>
      </div>

      {/* Right — user name + menu */}
      <div className="nav-right" ref={dropdownRef}>
        <div className="nav-user-info" onClick={() => setOpen(!open)}>
          <div className="nav-avatar">
            {userName?.charAt(0)?.toUpperCase() || "U"}
          </div>
          <span className="nav-username">{userName}</span>
          <i className={`fa-solid fa-chevron-${open ? "up" : "down"} nav-chevron`}></i>
        </div>

        {open && (
          <div className="user-dropdown">
            <div className="user-dropdown-header">
              <div className="user-dropdown-avatar">
                {userName?.charAt(0)?.toUpperCase() || "U"}
              </div>
              <div>
                <div className="user-dropdown-name">{userName}</div>
                <div className="user-dropdown-dairy">{dairyName}</div>
              </div>
            </div>

            <div className="user-dropdown-divider" />

            <Link
              to="/ChangePassword"
              className="user-dropdown-item"
              onClick={() => setOpen(false)}
            >
              <i className="fa-solid fa-lock"></i>
              <span>पासवर्ड बदला</span>
            </Link>

            <div className="user-dropdown-divider" />

            <Link
              to="/Logout"
              className="user-dropdown-item user-dropdown-logout"
              onClick={() => setOpen(false)}
            >
              <i className="fa-solid fa-right-from-bracket"></i>
              <span>लॉग आउट</span>
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Nav;
